import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { createSimpleFilterConfig } from '../factories/create-simple-filter-config';
import { PROGRAM_STATUSES } from '@src/shared/types/program';
import { FILTER_COLOR } from './filter-colors';

export const programStatusFilterConfig = createSimpleFilterConfig({
  facetName: 'status',
  color: FILTER_COLOR.pink,
  options: Object.values(PROGRAM_STATUSES).map((s) => ({
    label: formatTextForDisplay(s),
    value: s,
  })),
});
